import { IconButton, IntroistIcon, Stack } from "@introist/react-foundation/v2";

import { ProductMenuItem, WorkspaceSelectorProps } from "./types";
import { WorkspaceSelector } from "./WorkspaceSelector";

const ProductButton = ({ item }: { item: ProductMenuItem }) => (
  <IconButton
    icon={item.icon}
    size="large"
    tooltip={item.title}
    tooltipPlacement={"right" as any}
    dimmed={!item.active}
    variant={item.active ? "outlined" : "blended"}
    onClick={item.onClick}
  />
);

// The narrow rail on the far left for switching products. Shown only when the workspace has
// more than one product; the workspace selector then lives at its bottom.
export const ProductMenu = ({
  items,
  workspace
}: {
  items: ProductMenuItem[];
  workspace?: WorkspaceSelectorProps;
}) => {
  const topItems = items.filter(item => !item.bottom);
  const bottomItems = items.filter(item => item.bottom);

  return (
    <div
      style={{
        width: "50px",
        position: "fixed",
        height: "100vh",
        background: "var(--palette-surface-subdued)",
        borderRight: "1px solid var(--palette-surface-default)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "var(--spacing-large) 0",
        boxSizing: "border-box",
        gap: "var(--spacing-large)"
      }}
    >
      <IntroistIcon width="24px" height="24px" />
      {topItems.map(item => (
        <ProductButton key={item.key} item={item} />
      ))}

      <Stack vertical alignItems="center" style={{ marginTop: "auto" }}>
        {bottomItems.map(item => (
          <ProductButton key={item.key} item={item} />
        ))}
        {workspace && <WorkspaceSelector variant="logo" {...workspace} />}
      </Stack>
    </div>
  );
};
